import { OnInit, AfterViewInit, Component, ViewChild } from '@angular/core'
import { NzDividerModule } from 'ng-zorro-antd/divider'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { AtomModule } from '../../atom/atom.module'
import { CartService } from '../../service/cart.service';
import { PaymentService } from '../../service/payment.service'
import { PaymentStripeComponent } from '../../molecule/payment-stripe/payment-stripe.component'

enum Gateway {
  Stripe = 'STRIPE',
  Mollie = 'MOLLIE',
}

interface StripeConfig {
  scriptUrl: string;
  publishableKey: string;
  options: JSON;
}

interface MollieConfig {
  scriptUrl: string;
  options: JSON;
}

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrl: './payment.component.less',
  standalone: true,
  imports: [
    AtomModule,
    NzDividerModule,
    PaymentStripeComponent,
  ],
})
export class PaymentComponent implements OnInit {
  
  // active payment gateway
  gateway: string;
  
  // payment gateway configuration
  public stripeConfig: StripeConfig;
  public mollieConfig: MollieConfig;
  
  // prevent multiple clicks
  confirmingPayment = false;
  
  // total amount
  totalAmount: number;
  
  // currency code
  currencyCode: string;
  
  // agreement status
  agreementChecked = false;
  
  @ViewChild(PaymentStripeComponent, { static: false }) paymentStripeComponent?: PaymentStripeComponent
  
  constructor(
    private notificationService: NzNotificationService,
    private paymentService: PaymentService,
    private cartService: CartService,
  ) {}
  
  ngOnInit() {
    this.dedicatePaymentGateway()
  }
  
  dedicatePaymentGateway() {
    // Query backend to determine active payment gateway
    this.paymentService.fetchPaymentGatewayConfig().subscribe({ 
      next: (response) => {
        // TODO: Implement graceful fallback if gateway detection fails

        // Handle response from backend
        const data = response.data.paymentGatewayConfig
        if (!data) { 
           // TODO: Implement graceful fallback if gateway detection fails
          return 
        }
        
        this.gateway = data.gateway
        console.log(`this.gateway: ${this.gateway}`)
        if (this.gateway === Gateway.Stripe) { 
          console.log(`Stripe Config Initializing...`)
          this.stripeConfig = {
            scriptUrl: data.scriptUrl,
            publishableKey: data.publishableKey as string,
            options: data.options
          }
          
          console.log(`this.stripeConfig: ${JSON.stringify(this.stripeConfig)}`)
        }else if(this.gateway === Gateway.Mollie) {
          this.mollieConfig = {
            scriptUrl: data.scriptUrl,
            options: data.options
          }
        }
      },
      error: (error) => {
        // TODO: Implement graceful fallback if gateway detection fails
      }
    })
    
    this.cartService.fetchCartItems().subscribe(response => { 
      const activeOrder = response?.data?.activeOrder
      
      this.currencyCode = activeOrder?.currencyCode as string;
      this.totalAmount = activeOrder?.totalWithTax as number
    })
  }
  
  confirmPayment() {
    // prevent multiple clicks
    if (this.confirmingPayment) return;
    
    if (!this.agreementChecked) { 
      this.notificationService.error("Error", "Please agree to the terms and conditions")
      return
    }
    
    this.confirmingPayment = true;
    
    if (this.gateway === Gateway.Stripe) {
      this.paymentStripeComponent?.confirmPayment()
    }else if(this.gateway === Gateway.Mollie) {
      // TODO
    }
  }
  
  updateAgreement(event) {
    this.agreementChecked = !this.agreementChecked;
  }
}
